import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteAssetsRentRequestsDocument } from '@api/assetsRentDocuments';

import { IDeleteAssetRequestDocumentDTO } from '@interfaces/rent/dto/assetRentDocumentsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_REQUEST_DELETE_DOCUMENT, ASSET_REQUEST_DOCUMENTS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeleteAssetRequestDocument = (closeModal: () => void) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: deleteDocument,
		isLoading: isLoadingDeleteDocument,
	} = useMutation<IDeleteAssetRequestDocumentDTO>({
		mutationKey: [ASSET_REQUEST_DELETE_DOCUMENT],
		mutationFn: deleteAssetsRentRequestsDocument,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.deletedAssetRequestDocument,
				type: ESnackbarTypes.success,
			}));

			closeModal();

			return [queryClient.invalidateQueries([ASSET_REQUEST_DOCUMENTS])];
		},
		onError: () => {
			dispatch(setSnackbar({
				message: responseMessages.deleteErrorAssetRequestDocument,
				type: ESnackbarTypes.error,
			}));
		},
	});

	return {
		deleteDocument,
		isLoadingDeleteDocument,
	};
};
